import { render } from "./OverviewNav.vue?vue&type=template&id=b143ec20"
import script from "./OverviewNav.vue?vue&type=script&lang=js"
export * from "./OverviewNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__